import type { Transition, VariantType } from 'motion-v'

export const defaultTransition = (delay?: number): Transition<any> | undefined => {
   return {
      delay: delay || 0,
      type: 'spring',
      damping: 50,
      stiffness: 200,
      // duration: 0.6,
      // ease: 'easeInOut',
   }
}

export const defaultAnimate = (): VariantType => {
   return {
      opacity: 1,
      x: 0,
      y: 0,
      scale: 1,
   }
}

export const defaultInViewOptions = {
   once: true,
   margin: '-100px',
} as const
